<template>
  <div>
    <el-select v-model="testValue" @change="changePage" placeholder="请选择" :size="'small'" style="margin-bottom:15px">
      <el-option
        v-for="item in pageList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>

    <el-table
      border
      :data="tableList"
      style="width: 100%"
      @row-click="goDetail"
    >
      <el-table-column prop="patientName" label="姓名">
        <span style="color: #568156" slot-scope="scope">{{
          scope.row.maName
        }}</span>
      </el-table-column>
      <el-table-column prop="maSex" label="性别"> </el-table-column>
      <el-table-column prop="maAge" label="年龄"> </el-table-column>
      <el-table-column
        prop="maTelephone"
        label="联系方式"
        v-if="current == 'mmse'"
      >
      </el-table-column>
      <el-table-column prop="patientDegree" label="学历" v-else>
      </el-table-column>
      <el-table-column prop="maTotalScore" label="得分"> </el-table-column>
      <el-table-column prop="doctorName" label="医生"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link size="mini" style="margin-right:15px" type="primary"  @click.stop="goEdit(scope)"
            >编辑</el-link
          >
          <el-link size="mini" type="danger" @click.stop="deleteItem(scope)"
            >删除</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background  layout="prev, pager, next" :total="total" :current-page="pageNum" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { mmseList, deletemmse } from "../utils/mmse.js";
// import { mocaList, deletemoca } from "../utils/moca.js";
import { getListbox,getMmseListpage ,deletemmse} from "../utils/custom.js";
export default {
  name: "VueUserList",
  props: {
    current: {
      type: String,
      default: "mmse",
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableList: [],
      pageList: [],
      testValue:[],
      currentMmseId:''
    };
  },
  mounted(){
    this.getMMseList()
    const params = {
      userId: this.userInfo.userId,
    };
    getListbox(params).then((res) => {
      if (res.data) {
        const keyArray = Object.keys(res.data);
        keyArray.forEach((item) => {
          this.pageList.push({
            label: res.data[item],
            value: item,
          });
        });
      }
    });
    
  },
  methods: {
    changePage(e){
      this.currentMmseId = e;
      this.pageNum = 1;
      this.getMMseList()
    },
    goDetail(e) {
      console.log(e)
      this.$router.push({
        name:'testPage',
        query:{
            id:e.mmseId,
            opeartType:'query',
            testPageTitle:e.mmseTitle,
            ID:e.id
          },
      });
    },
    goEdit(item) {
      this.$router.push({
        path:  "./testPage" ,
        query: { id :item.row.mmseId,MMSEID:item.row.mmseId,ID:item.row.id ,opeartType:'edit',testPageTitle:item.row.mmseTitle},
      });
    },
    deleteItem(item) {
      const { id } = item.row;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await deletemmse(id) 
          this.getMMseList()
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getMMseList() {
      const params =  {
        userId: this.userInfo.userId,
        mmseId:this.currentMmseId
      }
      if(!params.mmseId){
        delete params.mmseId
      }
      const res = await getMmseListpage(this.pageNum, this.pageSize,params);
      this.tableList = res.rows;
      this.total = res.total * 1;
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getMMseList();
    },
  },
};
</script>
<style>
.el-table__row {
  cursor: pointer;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color:#568156;
  border-color:#568156
}
</style>
<style lang="less" scoped>
.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>
